import { render, staticRenderFns } from "./LgtClientLinks.vue?vue&type=template&id=8b9c0e70&scoped=true"
import script from "./LgtClientLinks.vue?vue&type=script&lang=js"
export * from "./LgtClientLinks.vue?vue&type=script&lang=js"
import style0 from "./LgtClientLinks.vue?vue&type=style&index=0&id=8b9c0e70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b9c0e70",
  null
  
)

export default component.exports